(function (scope) {

scope.SocialMediaShareEmail = function () {
	var me = this;
	me._form = $("form#share-email");
	me.init = function () {
		me._form.find ("input[type=submit]").on ("click.SocialMediaShareEmail", function (e) {
			e.preventDefault ();
			me.submit.apply (me);
			return false;
		});
		me._clickCloseOpenEmail = new ClickCloseOpen (".share-item.email .click-close-open", {
			onOpen: function () {
				$("#share-email").find ("input#share-to").focus ();
			}
		});
		me._form.find ("a.close").on ("click.SocialMediaShareEmail", function () {
			me._clickCloseOpenEmail.close ();
		});
		me._form.validate ();
	};
	me.submit = function () {
		var validCount = 0;
		var formItems = this._form.find ("*[required]");
		formItems.each (function () {
			if ($(this).valid ()) {
				validCount += 1;
			}
		});
		if (validCount == formItems.length) {
			$.ajax ({
				type: "POST",
				url: "/mail/send/share",
				data: this._form.serialize(),
				success: function (response) {
					response = JSON.parse (response);
					if (response.status == "ok") {
						me.showResult.apply (me, ["Shared!"]);
					} else {
						me.showResult.apply (me, [response.status]);
					}
				},
				error: function (response) {
					response = JSON.parse (response);
					me.showResult.apply (me, [response.status]);
				}
			});
		}

		return false;
	};
	me.showResult = function (result) {
		// console.log ("SocialMediaShareEmail.showResult", result);
		me._form.find ("input").prop ("disabled", true);
		me._form.find ("label.result").text (result);
		me._form.find ("label.result").show ();
		setTimeout (function () {
			me.resetForm ();
		}, 3000);
	};
	me.resetForm = function () {
		me._clickCloseOpenEmail.close ();
		me._form.find ("input").prop ("disabled", false);
		me._form.find ("input[type=text]:not(.visuallyhidden),input[type=email]:not(.visuallyhidden)").val ("");
		me._form.find ("label.result").text ("");
		me._form.find ("label.result").hide ();
	};
	if (me._form.length) {
		me.init ();
	}
};
	
}) (window);
